var NDConst = require('./constants');
var NavDataAccess = require('src/interlock/nav/nav-data-access');
var NavFactory = require('src/interlock/nav/nav-factory');
var NavPopulator = require('src/interlock/nav/nav-populator');
var NDSlideStorage = require('./slide-storage');
var carouselId = '#nav-drawer-carousel';
var arrayFind = require('array-find');

var SponsorshipConst = require('src/interlock/nav-sponsorship/constants');
var eventToolbox = require('src/interlock/no-ui/utils/event-toolbox/event-toolbox');

var slideNameArray = ['MAIN', 'CAR_TYPES_MAIN', 'CAR_FS_MAIN', 'RESEARCH_MAIN', 'RESEARCH_TOOLS', 'RESEARCH_TIPS',
    'RESEARCH_ARTICLE', 'RESEARCH_MANU_DETAILS', 'CAR_FS_TYPE', 'CAR_FS_MAKE', 'MODEL', 'YEAR'];

var NavDrawerController = function () {
    var drawerHeaderSelect = $('#nav-drawer .modal-header .select');
    var drawerHeaderText = $('#nav-drawer .modal-header .header');
    var drawerHeaderSearchForm = $('#nav-drawer .modal-header .search-form-wrap');
    var _self = this;

    var headerChange = function (isMain, text) {
        if (isMain) {
            drawerHeaderSelect.hide();
            drawerHeaderSearchForm.show();
        } else {
            drawerHeaderSelect.show();
            drawerHeaderSearchForm.hide();
        }
        if (text) {
            drawerHeaderText.text(text);
        }
    };

    this.headerState = function (slideNum) {
        var currentSlideNumName = arrayFind(slideNameArray, function (slideNumName) {
            return NDConst.SLIDE_NUMBER[slideNumName] === slideNum;
        });
        if(slideNum === NDConst.SLIDE_NUMBER.MAIN) {
            headerChange(true);
        } else if(currentSlideNumName) {
            headerChange(false, NDConst.DRAWER_HEADERS[currentSlideNumName]);
        } else {
            headerChange(false, NDConst.DRAWER_HEADERS.MAKE);
        }
    };

    this.listGroupItemSelect = function (dom) {
        var currentSlide = $(dom).data('currentSlide');
        var niceName = $(dom).data('niceName');
        var name = $(dom).data('name');
        var type = $(dom).data('type');
        var slideTo = $(dom).data('slideTo');

        if (type) {
            NavFactory.setMake({
                niceName: niceName,
                name: name
            });
            NavDataAccess.getModelYear({
                makeNiceName: niceName,
                type: type
            }, function() {
                NavPopulator.populateModels( _self, '', type, true );
            });

            this.fireGlobalNavImpressionTracking(type);
        } else {
            this.fireGlobalNavImpressionTracking($(dom).data('show'));
        }

        NDSlideStorage.addQueue(currentSlide);
        _self.headerState(slideTo);
        $(carouselId).carousel(slideTo);
    };

    this.modelAnchorSelect = function (dom, e) {
        e.preventDefault();
        var type = $( dom ).data('type');
        NavFactory.setModel({
            niceName: $( dom ).data('modelNiceId'),
            name: $( dom ).data('modelName')
        });
        NavFactory.setSubmodel({
            niceName: $( dom ).data('submodelNiceName'),
            name: $( dom ).data('submodelName')
        });
        NDSlideStorage.addQueue(NDConst.SLIDE_NUMBER.MODEL);
        NavPopulator.populateYears( _self, '', type, true );
        _self.headerState(NDConst.SLIDE_NUMBER.YEAR);
        $(carouselId).carousel(NDConst.SLIDE_NUMBER.YEAR);

        this.fireGlobalNavImpressionTracking(type);
    };

    this.fireGlobalNavImpressionTracking = function (navItem) {
        if(SponsorshipConst.NAV_ITEMS.indexOf(navItem) > -1 || SponsorshipConst.NAV_ITEMS_TYPES.indexOf(navItem) > -1) {
            eventToolbox.fireCustomEvent(SponsorshipConst.EVENT_TYPE_FIRE_IMPRESSION_TRACKING, {});
        }
    };

};

module.exports = NavDrawerController;


//////////////////
// WEBPACK FOOTER
// ./src/interlock/nav/drawer/controller.js
// module id = 68
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14